export default class PPaddMessageManagementForGF {

    #formId;
    #extraElements = [];

    constructor(formId) {
        this.#formId = formId;
    }

    addElementsByID(id) {
        this.#extraElements.push(id);
    }
    setElements() {
        const form = document.querySelector(this.#formId);
        let requiredElementsTab = [];
        if('undefined'!=typeof(form) && !!form){
            const requiredElements = form.querySelectorAll('[aria-required="true"]');

            requiredElements.forEach((element)=>{
                requiredElementsTab.push(element.id.split('_')[2]);
            });

            // requiredElementsTab.push('4');
            requiredElementsTab.push(...this.#extraElements ?? []);

            let getNextSibling = function (elem, selector){

                if(elem === null) return null;

                let sibling = elem.nextElementSibling;
                if (!selector) return sibling;
                while (sibling) {
                    if (sibling.matches(selector)) return sibling;
                    sibling = sibling.nextElementSibling
                }
            };

            const self = this;
            gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {

                if(parseInt(self.#formId.substring(7))==formId){

                    let validationMessage;
                    if('radio' == elem.type) {
                        validationMessage = getNextSibling(elem.parentNode.parentNode.parentNode,'.gfield_validation_message');
                    } else {
                        validationMessage = getNextSibling(elem.parentNode,'.gfield_validation_message');
                    }

                    const dotIndex = fieldId.indexOf('.');
                    fieldId = (dotIndex !== -1) ? fieldId.substring(0, dotIndex) : fieldId;

                    if(requiredElementsTab.includes(fieldId)) {

                        if('checkbox'==elem.type) {

                            if(elem.checked) {
                                (undefined!==validationMessage) ? validationMessage.style.display = 'none' : null;
                                elem.setAttribute("aria-invalid", "false");
                            } else {
                                (undefined!==validationMessage) ? validationMessage.style.display = 'block' : null;
                                elem.setAttribute("aria-invalid", "true");
                            }

                        } else if('radio'==elem.type) {

                            (undefined!==validationMessage) ? validationMessage.style.display = 'none' : null;
                            elem.parentNode.parentNode.parentNode.parentNode.classList.remove('gfield_error');

                        } else {

                            if(elem.value.length>0) {
                                (undefined!==validationMessage) ? validationMessage.style.display = 'none' : null;
                                elem.setAttribute("aria-invalid", "false");
                            } else {

                                if(validationMessage!==null) {
                                    (undefined!==validationMessage) ? validationMessage.style.display = 'block' : null;
                                    elem.setAttribute("aria-invalid", "true");
                                }

                            }

                        }

                    }

                }

            },10, 3 );

        }

    }
}